import { Lit3formBlock, html, unsafeHTML } from '@Root/lib/lit-3form-block';
import { isMobileLayout, isTabletLayout } from '../../../helpers/layout';
import { styles } from './css';

const MOBILE_COLUMNS = 2;
const TABLET_COLUMNS = 3;
const DESKTOP_COLUMNS = 5;

export class William extends Lit3formBlock {
  static get characterName() {
    return 'william';
  }

  static get characterProperties() {
    return {
      _columnCount: { type: Number },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  constructor() {
    super();
    this._columnCount = this.currentColumnCount;
    this._syncColumnCount = () => {
      this._columnCount = this.currentColumnCount;
    };
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('layout-shift-required', this._syncColumnCount);
    this._syncColumnCount();
  }

  disconnectedCallback() {
    document.removeEventListener(
      'layout-shift-required',
      this._syncColumnCount
    );
    super.disconnectedCallback();
  }

  get currentColumnCount() {
    if (isMobileLayout()) return MOBILE_COLUMNS;
    return isTabletLayout() ? TABLET_COLUMNS : DESKTOP_COLUMNS;
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid william-layout">
          <div class="william-body">
            ${this.headingHTML}
            <div class="william-entries">
              ${this.entriesHTML}
            </div>
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get entriesHTML() {
    if (!this.entries.length) return html``;

    return html`
      ${this.entryColumns.map(
        column => html`
          <div class="william-column">
            ${column.map(entry => this.entryHTML(entry))}
          </div>
        `
      )}
    `;
  }

  /* Dealt round-robin so an entry keeps the column it had when the whole
     set shared one grid, while each column now stacks on its own. */
  get entryColumns() {
    const columns = Array.from({ length: this._columnCount }, () => []);
    this.entries.forEach((entry, index) => {
      columns[index % this._columnCount].push(entry);
    });
    return columns.filter(column => column.length);
  }

  entryHTML(entry) {
    const label = (entry.header || '').trim();
    return html`
      <div class="william-entry">
        ${label
          ? html`
              <p class="william-entry-label">
                ${unsafeHTML(this.withLineBreaks(label))}
              </p>
            `
          : html``}
        <div class="william-entry-value">
          ${unsafeHTML(entry.text || '')}
        </div>
      </div>
    `;
  }

  get headingHTML() {
    if (!this.heading) return html``;
    return html`
      <p class="william-heading">${unsafeHTML(this.heading)}</p>
    `;
  }

  get heading() {
    return this.content.heading || '';
  }

  get entries() {
    return this.content.entries || [];
  }
}
William.defineElement();
